module.exports = __webpack_public_path__ + "static/share@2x-8a99f03c7e1c5f7ca296143900178426.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/wireframing/share@2x.png
// module id = 2625
// module chunks = 168707334958949